import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './style.css';
import PageTitle from '../../components/pagetitle';

const GalleryPage = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const galleryCategories = [
        {
            id: 'bharatanatyam',
            title: 'Bharatanatyam',
            description: 'Classical South Indian dance form characterized by grace and precision',
            images: [
                { src: require('../../images/blog/img-1.jpg'), alt: 'Bharatanatyam Performance 1' },
                { src: require('../../images/blog/img-2.jpg'), alt: 'Bharatanatyam Performance 2' },
                { src: require('../../images/blog/img-3.jpg'), alt: 'Bharatanatyam Performance 3' },
                { src: require('../../images/blog/img-4.jpg'), alt: 'Bharatanatyam Performance 4' },
                { src: require('../../images/blog/img-5.jpg'), alt: 'Bharatanatyam Performance 5' },
                { src: require('../../images/blog/img-6.jpg'), alt: 'Bharatanatyam Performance 6' },
            ]
        },
        {
            id: 'bhangra',
            title: 'Bhangra',
            description: 'Energetic Punjabi folk dance known for its lively movements and music',
            images: [
                { src: require('../../images/blog/img-1.jpg'), alt: 'Bharatanatyam Performance 1' },
                { src: require('../../images/blog/img-2.jpg'), alt: 'Bharatanatyam Performance 2' },
                { src: require('../../images/blog/img-3.jpg'), alt: 'Bharatanatyam Performance 3' },
                { src: require('../../images/blog/img-4.jpg'), alt: 'Bharatanatyam Performance 4' },
                { src: require('../../images/blog/img-5.jpg'), alt: 'Bharatanatyam Performance 5' },
                { src: require('../../images/blog/img-6.jpg'), alt: 'Bharatanatyam Performance 6' },
            ]
        },
        {
            id: 'garba',
            title: 'Garba',
            description: 'Traditional Gujarati dance performed during Navratri festival',
            images: [
                { src: require('../../images/blog/img-1.jpg'), alt: 'Bharatanatyam Performance 1' },
                { src: require('../../images/blog/img-2.jpg'), alt: 'Bharatanatyam Performance 2' },
                { src: require('../../images/blog/img-3.jpg'), alt: 'Bharatanatyam Performance 3' },
                { src: require('../../images/blog/img-4.jpg'), alt: 'Bharatanatyam Performance 4' },
                { src: require('../../images/blog/img-5.jpg'), alt: 'Bharatanatyam Performance 5' },
                { src: require('../../images/blog/img-6.jpg'), alt: 'Bharatanatyam Performance 6' },
            ]
        }
    ];

    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={'Our Gallery'} pagesub={'Gallery'}/> 

            <section className="gallery-page-section">
                <div className="container">
                    {galleryCategories.map((category) => (
                        <div key={category.id} className="gallery-category">
                            <div className="category-header">
                                <h3>{category.title}</h3>
                                <p>{category.description}</p>
                            </div>
                            <div className="gallery-carousel">
                                <Slider {...settings}>
                                    {category.images.map((image, index) => (
                                        <div key={index} className="gallery-item">
                                            <img src={image.src} alt={image.alt} />
                                            <div className="gallery-overlay">
                                                <div className="overlay-content">
                                                    <h4>{category.title}</h4>
                                                    <p>Click to view</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default GalleryPage;
